import { render, staticRenderFns } from "./BusinessBasicDataView.vue?vue&type=template&id=4181abac&scoped=true&"
import script from "./BusinessBasicDataView.vue?vue&type=script&lang=ts&"
export * from "./BusinessBasicDataView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessBasicDataView.vue?vue&type=style&index=0&id=4181abac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181abac",
  null
  
)

export default component.exports